// extracted by mini-css-extract-plugin
module.exports = {"download-bar":"download-bar___au3Ve","close":"close___gcxUg","logo":"logo___3iVFO","cont":"cont___1srha","tit":"tit___1o2wb","desc":"desc___29X1m","down":"down___3hxbJ"};